import { AbstractCommand } from 'src/models/command';

class ConvertAttachmentToDocumentCommand extends AbstractCommand {
	readonly name = 'IFS_AttachmentToDocument_TransparentCQRS_Commands_ConvertAttachmentToDocumentCommand';

	public constructor(storageKey: string, attachmentId: number, postboxId: number) {
		super();
		this.parameters = {
			attachmentId,
			postboxId,
			storageKey,
		};
	}
}

export { ConvertAttachmentToDocumentCommand };
